import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=5a07ce4c&scoped=true"
import script from "./ExpansionPanel.vue?vue&type=script&lang=js"
export * from "./ExpansionPanel.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=5a07ce4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a07ce4c",
  null
  
)

export default component.exports